import { Control, FieldValues, Path } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';

interface SwitchFieldProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  disabled?: boolean;
  onCheckedChange?: (value: boolean) => void;
}

export function SwitchField<T extends FieldValues>({
  name,
  control,
  label,
  disabled = false,
  onCheckedChange,
}: SwitchFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex items-center gap-3 space-y-0">
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={value => {
                field.onChange(value);
                onCheckedChange?.(value);
              }}
              disabled={disabled}
            />
          </FormControl>
          <FormLabel className="font-medium">{label}</FormLabel>
        </FormItem>
      )}
    />
  );
}
